var User = require('user');


var UserList = Backbone.Collection.extend({
    model: User
});


module.exports = UserList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/userlist.js
// module id = jGPP
// module chunks = 1